import { render } from "./UploadCategory.vue?vue&type=template&id=06c3ec6f&scoped=true"
import script from "./UploadCategory.vue?vue&type=script&lang=js"
export * from "./UploadCategory.vue?vue&type=script&lang=js"

import "./UploadCategory.vue?vue&type=style&index=0&id=06c3ec6f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c3ec6f"]])

export default __exports__